module.exports = __webpack_public_path__ + "media/img/testimonial/raymond_howe-9c68862d42ea6a3f8a9b79b1a7592fa8.jpeg";